/*
 * @Author: wsx
 * @Date: 2022-01-21 14:58:23
 * @LastEditTime: 2022-01-21 14:59:37
 * @LastEditors: your name
 * @Description: 对讲
 */
import { request } from "../utils/request";
import { getTalkReqBody } from "../utils/util";

let initTalkId = ""; // 对讲控件容器的 id

class Talk {
  /**
   * @Description: 对讲控件初始化
   * @param {string} id 对讲控件绑定的Dom的id
   */
  initTalk(id) {
    // 当 webcket 未连接时把事件缓存起来
    if (!this.connected) {
      this.eventCacheFn(this.initTalk, [id]);
      return;
    }
    const that = this;
    initTalkId = id || initTalkId;
    const reqBody = getTalkReqBody(initTalkId);

    window.onbeforeunload = function(e) {
      /// /监听地址切换事件
      that.hideTalk();
    };
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        request("Talk.Init", reqBody, {
          resolve,
          reject
        });
      }, 100);
    });
  }
  /**
   * @Description: 对讲控件重置位置
   * @param {string} id 对讲控件绑定的Dom的id
   */

  resizeTalk(id) {
    initTalkId = id || initTalkId;
    const reqBody = getTalkReqBody(initTalkId);

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        request("Talk.Resize", reqBody, {
          resolve,
          reject
        });
      }, 100);
    });
  }

  /**
   * 对讲控件隐藏
   */
  hideTalk() {
    return new Promise((resolve, reject) => {
      request("Talk.FrmHide", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * 对讲控件显示
   */
  showTalk() {
    return new Promise((resolve, reject) => {
      request("Talk.FrmShow", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 开始对讲
   * {
   *  @param {String} talkServerId      对讲服务编号 NOT  NULL
      @param {String} talkServerName    对讲服务名称
      @param {String} talkServerOtherId 服务第三方编号
      @param {String} talkServerBrand   服务品牌 NOT  NULL
      @param {String} talkServerIp      服务Ip
      @param {String} talkServerPort    服务端口
      @param {String} talkServerUser    服务用户名
      @param {String} talkServerPsw     服务密码
      @param {String} talkId            对讲机编号 NOT  NULL
      @param {String} talkName          对讲机名称 NOT  NULL 对讲机名称
      @param {String} otherId           第三方编号 NOT  NULL
      @param {String} talkBrand         对讲机品牌 NOT  NULL
      @param {String} talkType          对讲机类型 NOT  NULL 对讲机类型  1 主机 2 分机
      @param {String} talkIp            对讲机IP
      @param {String} talkPort          对讲机端口
      @param {String} talkUser          对讲机用户
      @param {String} talkPsw           对讲机密码
    * }
    */
  talkStart(reqBody) {
    return new Promise((resolve, reject) => {
      request("Talk.TalkStart", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 停止对讲
   * @param {reqBody} 请求实体同开始对讲一样
   */
  talkStop(reqBody) {
    return new Promise((resolve, reject) => {
      request("Talk.TalkStop", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 开始循环监听
   * @param {reqBody} 请求实体同开始对讲一样
   */
  talkLoopListenStart(reqBody) {
    return new Promise((resolve, reject) => {
      request("Talk.LoopListenStart", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 停止循环监听
   * @param {reqBody} 请求实体同开始对讲一样
   */
  talkLoopListenStop(reqBody) {
    return new Promise((resolve, reject) => {
      request("Talk.LoopListenStop", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 开始监听
   * @param {reqBody} 请求实体同开始对讲一样
   */
  talkListenStart(reqBody) {
    return new Promise((resolve, reject) => {
      request("Talk.ListenStart", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 停止监听
   * @param {reqBody} 请求实体同开始对讲一样
   */
  talkListenStop(reqBody) {
    return new Promise((resolve, reject) => {
      request("Talk.ListenStop", reqBody, {
        resolve,
        reject
      });
    });
  }
}
export default Talk;
